// CompanySelect.jsx
import React, { useEffect, useState } from "react";
import { Select, MenuItem } from "@mui/material";

const AccessLevelSelect = ({ value, onChange, label = "Access Level", ...props }) => {
  const [selectedValue, setSelectedValue] = useState(value.split(":")[1]);

  const handleSelect = (e) => {
    setSelectedValue(e.target.value);
    onChange(`${value.split(":")[0]}:${e.target.value}`);
  };

  const levels = [
    { id: 0, label: "Blocked" },
    { id: 1, label: "View Only" },
    { id: 2, label: "View, Create, Edit" },
    { id: 3, label: "View, Create, Edit, Delete" },
  ];

  // 🎨 Color mapping using theme palette keys
  const levelColors = {
    0: "error.main",   
    1: "secondary.main",    
    2: "info.main", 
    3: "success.main", 
  };

  return (
    <Select
      value={selectedValue}
      onChange={handleSelect}
      label={label}
      size="small"
      variant="standard"
      fullWidth
      // Apply color to the selected value
      sx={{
        color: levelColors[selectedValue],
      }}
    >
      {levels.map((level) => (
        <MenuItem
          key={level.id}
          value={level.id}
        >
          {level.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default AccessLevelSelect;
